// extracted by mini-css-extract-plugin
export var contact = "Aside-module--contact--78ac0";
export var socials = "Aside-module--socials--a8d73";